module.exports = __webpack_public_path__ + "media/cookies/cookie-warning-5f6de5c9.svg";